import React from 'react';
import PropTypes from 'prop-types';
//
import Modal from 'antd/lib/modal';
import DownloadPDFButton from 'components/common/DownloadPDFButton';
import Caption from 'components/text/Caption';
import Body from 'components/text/Body';

const styles = {
  resultItemContainer: {
    padding: 8,
    margin: 15,
    borderRadius: 4,
    border: '1px solid #efefef',
  },
};

const ResultItem = ({ result, componentType }) => {
  const baseStyle = { color: '#000', margin: 0 };
  const style = {
    fontSize: componentType === 'pdf' ? '9px' : '16px',
    fontWeight: 'normal',
  };

  return (
    <div style={styles.resultItemContainer}>
      <Caption style={{ ...baseStyle, ...style }}>{result.question}</Caption>
      <Body style={{ ...style }}>{result.answer}</Body>
    </div>
  );
};

export const QuestionnairePreviewComponent = ({ selected, componentType }) => (
  <div>
    {selected
      && selected.results
      && selected.results.map(result => {
        const key = `${result.question}${result.answer}`;
        return <ResultItem key={key} result={result} componentType={componentType} />;
      })}
  </div>
);

QuestionnairePreviewComponent.propTypes = {
  // selected: PropTypes.bool,
  componentType: PropTypes.oneOf(['pdf', 'html']),
};

QuestionnairePreviewComponent.defaultProps = {
  // selected: false,
  componentType: 'html',
};

export class QuestionnairePreview extends React.Component {
  render() {
    if (!this.props.selected) {
      return null;
    }
    return (
      <Modal
        title="QUESTIONNAIRE RESULTS"
        onCancel={() => this.props.onCancel()}
        onOk={() => this.props.onCancel()}
        visible={this.props.visible}
        okText="DOWNLOAD PDF"
        footer={null}
        cancelText="CLOSE"
      >
        <QuestionnairePreviewComponent selected={this.props.selected} componentType={this.props.componentType} />
        <DownloadPDFButton downloadType="questionnaire" size="large" record={this.props.selected} />
      </Modal>
    );
  }
}

export default QuestionnairePreview;



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientQuestionnaires/QuestionnairePreview/index.js